import { type AppState, Auth0Provider, type Auth0ProviderOptions } from '@auth0/auth0-react'
import { useCallback, type PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

export type Auth0ProviderWithNavigateProps = PropsWithChildren<{
  config: Auth0ProviderOptions
}>

// Must render inside BrowserRouter: only a router navigation clears the Auth0 code/state from its location.
export const Auth0ProviderWithNavigate = ({ config, children }: Auth0ProviderWithNavigateProps) => {
  const navigate = useNavigate()

  const onRedirectCallback = useCallback(
    (appState?: AppState) => {
      // A partial path resolves against the router location; window.location.pathname would repeat the basename.
      navigate(appState?.returnTo ?? { search: '', hash: '' }, { replace: true })
    },
    [navigate],
  )

  return (
    <Auth0Provider {...config} onRedirectCallback={onRedirectCallback}>
      {children}
    </Auth0Provider>
  )
}
